import React from 'react';

const CookiePolicy = () => {
  return (
    <div>
      <iframe
        title="cookiePolicyFrame"
        width="100%"
        style={{ height: '95vh' }}
        src="https://app.termly.io/document/cookie-policy/2de5b25e-c56e-4a71-88d0-7e54deb1790c"
        frameborder="0"
        allowfullscreen
      >
        <p>Your browser does not support iframes.</p>
      </iframe>
    </div>
  );
};

export default CookiePolicy;



// WEBPACK FOOTER //
// ./src/components/CookiePolicy.js